import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import servicioHttp from '../servicio/ServicioHttp';
import { Growl } from "primereact/growl";
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import servicioObjetos from '../servicio/ServicioObjetos';
import { Message } from 'primereact/message';

const MENSAJE_REQUERIDO = "Información requerida";
export class TasaRecargo extends React.Component {


    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 30 },
            tasa: {},
            errores: {},
            mostrarDialogAgregar: false,
            mostrarDialogEditar: false,
            mostrarDialogEliminar: false,
            desarrollador: false
        };
    }

    componentDidMount() {
        this.tasaRecargo();
        this.obtnerUsuarioDesarrollador();
    }

    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }

    tasaRecargo = () => {
        servicioHttp.consumirPostHttp("recargos/consulta_tasa_recargos.json").then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {
        });
    }

    columnaEnero = (rowData, column) => {
        return <div>{rowData.enero}%</div>;
    }
    columnaFebrero = (rowData, column) => {
        return <div>{rowData.febrero}%</div>;
    }
    columnaMarzo = (rowData, column) => {
        return <div>{rowData.marzo}%</div>;
    }
    columnaAbril = (rowData, column) => {
        return <div>{rowData.abril}%</div>;
    }
    columnaMayo = (rowData, column) => {
        return <div>{rowData.mayo}%</div>;
    }
    columnaJunio = (rowData, column) => {
        return <div>{rowData.junio}%</div>;
    }
    columnaJulio = (rowData, column) => {
        return <div>{rowData.julio}%</div>;
    }
    columnaAgosto = (rowData, column) => {
        return <div>{rowData.agosto}%</div>;
    }
    columnaSeptiembre = (rowData, column) => {
        return <div>{rowData.septiembre}%</div>;
    }
    columnaOctubre = (rowData, column) => {
        return <div>{rowData.octubre}%</div>;
    }
    columnaNoviembre = (rowData, column) => {
        return <div>{rowData.noviembre}%</div>;
    }
    columnaDiciembre = (rowData, column) => {
        return <div>{rowData.diciembre}%</div>;
    }

    mostrarModalAgregar = () => {
        this.setState({ mostrarDialogAgregar: true });
    };

    mostrarModalEditar = () => {
        this.setState({ mostrarDialogEditar: true });
    };

    cerrarModalAgregar = () => {
        this.setState({
            mostrarDialogAgregar: false
        });
        this.reset();
    }

    cerrarModalEditar = () => {
        this.setState({
            mostrarDialogEditar: false
        });
        this.reset();
    }

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalEliminar: true, tasa: objeto });
    }

    cerrarModalEliminar = () => {
        this.setState({ mostrarModalEliminar: false });
        this.reset();
    }

    reset = () => {
        this.setState({
            tasa: {},
            errores: {}
        });
    }

    asignaValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    validarFormulario = (inpc) => {
        let errores = {};

        if (servicioObjetos.esObjetoVacio(inpc.anio)) {
            errores.anio = MENSAJE_REQUERIDO;
        }
        return errores;
    }

    guardarTasa = () => {
        let { tasa } = this.state;
        let guardaTasa = { ...tasa };
        let validForm = this.validarFormulario(guardaTasa);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            guardaTasa.anio = tasa.anio;
            guardaTasa.enero = tasa.enero;
            guardaTasa.febrero = tasa.febrero;
            guardaTasa.marzo = tasa.marzo;
            guardaTasa.abril = tasa.abril;
            guardaTasa.mayo = tasa.mayo;
            guardaTasa.junio = tasa.junio;
            guardaTasa.julio = tasa.julio;
            guardaTasa.agosto = tasa.agosto;
            guardaTasa.septiembre = tasa.septiembre;
            guardaTasa.octubre = tasa.octubre;
            guardaTasa.noviembre = tasa.noviembre;
            guardaTasa.diciembre = tasa.diciembre;
            servicioHttp.consumirPostHttp("recargos/guardar_tasa_recargos.json", guardaTasa).then((response) => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalAgregar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    actualizar(rowData) {
        var tasaEditar = JSON.parse(JSON.stringify(rowData));
        this.setState({ mostrarDialogEditar: true, tasa: tasaEditar });
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(column.rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar información">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar registro" >
                </Button>
            </div>
        </div>;
    }

    editarTasa = () => {
        let { tasa } = this.state;
        let validForm = this.validarFormulario(tasa);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            servicioHttp.consumirPostHttp("recargos/actualizar_tasa_recargos.json", tasa).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalEditar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    eliminar = () => {
        let { tasa } = this.state;
        servicioHttp.consumirPostHttp("recargos/recargos_eliminar.json", tasa).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.componentDidMount();
            this.cerrarModalEliminar();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })

    }


    render() {
        let { paginacion, tasa, errores, mostrarDialogAgregar, mostrarDialogEditar, mostrarModalEliminar, desarrollador } = this.state;
        let pieTablaBotones = <div className="p-fluid p-grid">
        <div className="p-col-12 p-md-3">
            {desarrollador ?
                <Button className="p-button-secondary" type="button" name="agregarEjercicio" label="Agregar Ejercicio" tooltip="Agregar Ejercicio" onClick={this.mostrarModalAgregar}></Button>
                : null}
        </div>
    </div>;
        const pieDialogoExaminar = (
            <div>
                <Button icon="pi-md-save" onClick={this.guardarTasa} label="Guardar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalAgregar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogo = (
            <div>
                <Button icon="pi-md-check" onClick={this.editarTasa} label="Aceptar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEditar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminar} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (

            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-whiteg">
                    <div className="p-grid">
                        <div className="col-12 p-md-12">
                            <h1>TASA DE RECARGOS</h1>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <label></label>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <DataTable footer={pieTablaBotones} value={paginacion.datos} header="TASA DE RECARGOS" resizableColumns={true} responsive={true} paginator={true} rows={10}>
                                <Column header="AÑO" field="anio" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="ENERO" body={this.columnaEnero} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="FEBRERO" body={this.columnaFebrero} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="MARZO" body={this.columnaMarzo} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="ABRIL" body={this.columnaAbril} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="MAYO" body={this.columnaMayo} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="JUNIO" body={this.columnaJunio} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="JULIO" body={this.columnaJulio} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="AGOSTO" body={this.columnaAgosto} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="SEPTIEMBRE" body={this.columnaSeptiembre} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="OCTUBRE" body={this.columnaOctubre} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="NOVIEMBRE" body={this.columnaNoviembre} style={{ width: '150px' }} autoLayout={true} />
                                <Column header="DICIEMBRE" body={this.columnaDiciembre} style={{ width: '150px' }} autoLayout={true} />
                                {desarrollador === true ?
                                    <Column header="OPCIONES" body={this.plantillaOpciones} style={{ width: '90px' }} autoLayout={true} />
                                    : null}
                            </DataTable>
                        </div>

                        <Dialog style={{ width: '40%', height: '60%' }} appendTo={document.body} header="Agregar Tasa de Recargos" visible={mostrarDialogAgregar}
                            modal={true} onHide={this.cerrarModalAgregar} footer={pieDialogoExaminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>*Año:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.anio" name="tasa.anio" value={tasa.anio || ""}
                                        className={errores.anio ? "p-error" : ""} placeholder="YYYY" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="4" style={{ width: "100%" }} keyfilter="pint" />
                                    {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Enero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.enero" name="tasa.enero" value={tasa.enero || ""}
                                        className={errores.enero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Febrero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.febrero" name="tasa.febrero" value={tasa.febrero || ""}
                                        className={errores.febrero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Marzo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.marzo" name="tasa.marzo" value={tasa.marzo || ""}
                                        className={errores.marzo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Abril:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.abril" name="tasa.abril" value={tasa.abril || ""}
                                        className={errores.abril ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Mayo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.mayo" name="tasa.mayo" value={tasa.mayo || ""}
                                        className={errores.mayo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Junio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.junio" name="tasa.junio" value={tasa.junio || ""}
                                        className={errores.junio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Julio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.julio" name="tasa.julio" value={tasa.julio || ""}
                                        className={errores.julio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Agosto:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.agosto" name="tasa.agosto" value={tasa.agosto || ""}
                                        className={errores.agosto ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Septiembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.septiembre" name="tasa.septiembre" value={tasa.septiembre || ""}
                                        className={errores.septiembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Octubre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.octubre" name="tasa.octubre" value={tasa.octubre || ""}
                                        className={errores.octubre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Noviembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.noviembre" name="tasa.noviembre" value={tasa.noviembre || ""}
                                        className={errores.noviembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Diciembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.diciembre" name="tasa.diciembre" value={tasa.diciembre || ""}
                                        className={errores.diciembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '40%', height: '60%' }} appendTo={document.body} header="Editar Tasa de Recargos" visible={mostrarDialogEditar}
                            modal={true} onHide={this.cerrarModalEditar} footer={pieDialogo}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>*Año:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.anio" name="tasa.anio" value={tasa.anio || ""}
                                        className={errores.anio ? "p-error" : ""} placeholder="YYYY" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="4" style={{ width: "100%" }} keyfilter="pint" />
                                    {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Enero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.enero" name="tasa.enero" value={tasa.enero || ""}
                                        className={errores.enero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Febrero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.febrero" name="tasa.febrero" value={tasa.febrero || ""}
                                        className={errores.febrero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Marzo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.marzo" name="tasa.marzo" value={tasa.marzo || ""}
                                        className={errores.marzo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Abril:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.abril" name="tasa.abril" value={tasa.abril || ""}
                                        className={errores.abril ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Mayo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.mayo" name="tasa.mayo" value={tasa.mayo || ""}
                                        className={errores.mayo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Junio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.junio" name="tasa.junio" value={tasa.junio || ""}
                                        className={errores.junio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Julio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.julio" name="tasa.julio" value={tasa.julio || ""}
                                        className={errores.julio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Agosto:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.agosto" name="tasa.agosto" value={tasa.agosto || ""}
                                        className={errores.agosto ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Septiembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.septiembre" name="tasa.septiembre" value={tasa.septiembre || ""}
                                        className={errores.septiembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Octubre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.octubre" name="tasa.octubre" value={tasa.octubre || ""}
                                        className={errores.octubre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Noviembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.noviembre" name="tasa.noviembre" value={tasa.noviembre || ""}
                                        className={errores.noviembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Diciembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="tasa.diciembre" name="tasa.diciembre" value={tasa.diciembre || ""}
                                        className={errores.diciembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar registro - Tasa Recargo" visible={mostrarModalEliminar} modal={true}
                            footer={pieDialogEliminar} onHide={this.cerrarModalEliminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}